import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const ModalWrapper = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
`;
export const BlackBackground = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
export const ModalContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: fit-content;
  max-height: 96%;
  /* transform: translate(-50%, -50%); */
  background-color: ${COLORS.white};
  /* height: 500px; */
  padding: 68px 16px 32px 16px;
  @media ${device.tablet} {
    height: fit-content;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 48px 48px 52px 48px;
    max-width: 95%;
    min-width: 768px;
  }
  @media ${device.laptop} {
    padding: 52px 60px 64px 60px;
    width: 1024px;
  }
  z-index: 99999;
`;

export const TitleWrapper = styled.div`
  margin-top: 28px;
  margin-bottom: 28px;
  @media ${device.tablet} {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  @media ${device.tablet} {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`;

export const TitleFinanceAndLease = styled.h4`
  font-family: Audi Type Extended;
  letter-spacing: 0.001px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${COLORS.grey80};
`;

export const ModelName = styled.h3`
  font-family: Audi Type Extended;
  letter-spacing: 0.001px;
  font-size: 20px;
  line-height: 32px;
  color: ${COLORS.grey80};
`;

export const Title = styled.h3<{ isBold?: boolean; isExtended?: boolean }>`
  margin: 0;
  font-family: ${({ isExtended }) => (isExtended ? 'Audi Type Extended' : 'Audi Type')};
  letter-spacing: 0.001px;
  font-size: 24px;
  line-height: 36px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${COLORS.grey80};
  @media ${device.tablet} {
    font-size: 20px;
    line-height: 32px;
  }
  @media ${device.laptop} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const MSRP = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const MainTextWrapper = styled.div`
  margin-top: 28px;
  margin-bottom: 16px;
  max-height: 160px;
  overflow-y: auto;
  white-space: pre-wrap;
  @media ${device.tablet} {
    max-height: 280px;
    margin-top: 24px;
    margin-bottom: 12px;
  }
  @media ${device.laptop} {
    margin-bottom: 24px;
  }
`;

export const PaymentsWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const CTAsContainer = styled.div<{ leftAlign?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 28px;
  @media ${device.tablet} {
    flex-direction: row;
    margin-top: 32px;
    justify-content: ${(props) => (props.leftAlign ? 'flex-start' : 'flex-end')};
  }
  @media ${device.laptop} {
    margin-top: 24px;
  }
`;

export const PrimaryCTA = styled.a`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.black};
  border: none;
  width: 100%;
  padding: 16px 32px;
  font-family: 'Audi Type';
  color: ${COLORS.white};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
  @media ${device.tablet} {
    width: max-content;
  }
`;

export const SecondaryCTA = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  box-shadow: inset 0 0 0 1px ${COLORS.black};
  width: 100%;
  padding: 16px 32px;
  font-family: 'Audi Type';
  color: ${COLORS.black};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
  @media ${device.tablet} {
    width: max-content;
  }
`;

export const CloseModalButton = styled.button`
  padding: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 1px;
  right: 1px;
  display: flex;
  justify-content: flex-end;
  background-color: ${COLORS.white};
`;
